















import { defineComponent } from '@vue/composition-api'
import ProductList from '@/components/products/ProductList.vue'

export default defineComponent({
  components: { ProductList },
  props: {
    category: {
      required: true,
      type: Object,
    },
  },
})
